// @ts-strict-ignore
import React from "react";
import { Helmet } from "react-helmet";

interface Props {
	title: string;
	description?: string;
	tags?: string;
}

const MetaTags : React.FC<Props> = ({
	title,
	description,
	tags
}) => {
	return (
		<Helmet>
			<title>{title}</title>
				
			{description ? <meta name="description" content={description.slice(0, 200)} /> : null}
				
			{tags ? <meta name="tags" content={tags} /> : null}
		</Helmet>
	);
};

export default MetaTags;
